import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import { useShangpinguigeUpdateQuery, useShangpinguigeUpdateSaveMutation,} from '../../store/dianshangtaizhangApi';
import GoodsSelect from '../goods/GoodsSelect';
import { EditOutlined } from '@ant-design/icons';
function GoodsSpecEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bg_content:''
    }); 
    const {data,isSuccess} = useShangpinguigeUpdateQuery({spgg_id:props.spgg_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    spgg_sp_name:data.Result.spgg_sp_name,
                    spgg_price:data.Result.spgg_price,
                    spgg_day:data.Result.spgg_day,
                    spgg_name:data.Result.spgg_name,
                    spgg_content:data.Result.spgg_content,
                    spgg_bianhao:data.Result.spgg_bianhao,
                    spgg_report_template:data.Result.spgg_report_template,
                    spgg_approve_rule:data.Result.spgg_approve_rule,
                })
                setInfo(prevState=>({...prevState,
                    spgg_sp_id:data.Result.spgg_sp_id,
                    spgg_sp_name:data.Result.spgg_sp_name,
                    spgg_price:data.Result.spgg_price,
                    spgg_day:data.Result.spgg_day,
                    spgg_name:data.Result.spgg_name,
                    spgg_content:data.Result.spgg_content,      
                    spgg_bianhao:data.Result.spgg_bianhao,      
                    spgg_report_template:data.Result.spgg_report_template,
                    spgg_approve_rule:data.Result.spgg_approve_rule,
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useShangpinguigeUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined />修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改商品规格'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "spgg_content" : info.spgg_content,
                        "spgg_day" : info.spgg_day,
                        "spgg_id" : props.spgg_id,
                        "spgg_name" : info.spgg_name,
                        "spgg_price" : info.spgg_price,
                        "spgg_sp_id" : info.spgg_sp_id,
                        "spgg_sp_name" : info.spgg_sp_name,
                        "spgg_bianhao" : info.spgg_bianhao,
                        "spgg_report_template" : info.spgg_report_template,
                        "spgg_approve_rule" : info.spgg_approve_rule,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <GoodsSelect
                        label="商品"          
                        name="spgg_sp_name"                        

                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,spgg_sp_id:e,spgg_sp_name:f}))
                        }}
                        wrapperCol={{span:10}}
                    />                 
                    <Form.Item name="spgg_name" wrapperCol={{span:10}} required label='规格名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_name:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="spgg_price" wrapperCol={{span:10}} required label='规格价格'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_price:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="spgg_day" wrapperCol={{span:10}} required label='天数'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_day:e.target.value}))
                        }}/>
                    </Form.Item>  
                    <Form.Item name="spgg_bianhao" wrapperCol={{span:10}} required label='编号'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_bianhao:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="spgg_report_template" wrapperCol={{span:10}} required label='团队报账单模板'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_report_template:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="spgg_approve_rule" wrapperCol={{span:10}}  required label='审批类型'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_approve_rule:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="spgg_content" wrapperCol={{span:10}}  label='备注'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_content:e.target.value}))
                        }}/>
                    </Form.Item>                       
                </Form>
            </Modal>
        </>
    )
}

export default GoodsSpecEdit